<template>
  <div class="wrapper">
    <notifications></notifications>
    <div class="main-content" v-if="branch">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <loader></loader>
    </div>
    <select-branch v-else></select-branch>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { mapGetters, mapActions, mapMutations } from "vuex";
import loader from "@/components/Loader";
import selectbranch from "../../Dispatch/Components/SelectBranch";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import { FadeTransition } from "vue2-transitions";
export default {
  components: {
    DashboardNavbar,
    FadeTransition,
    loader,
    "select-branch": selectbranch,
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
  computed: {
    ...mapGetters(["loader", "branch"]),
  },
};
</script>

<style lang="scss" scope>
</style>
